import { FC, ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material';
import { QcsTypography } from './QcsTypography';

interface ReadOnlyFieldProps {
  label: string;
  children?: ReactNode;
  valueSx?: SxProps<Theme>;
}

export const ReadOnlyField: FC<ReadOnlyFieldProps> = ({ label, children, valueSx }) => (
  <>
    <QcsTypography variant="caption" sx={{ color: 'text.secondary' }}>
      {label}
    </QcsTypography>
    {children !== undefined &&
      (typeof children === 'string' ? (
        <QcsTypography variant="body2" sx={valueSx}>
          {children}
        </QcsTypography>
      ) : (
        children
      ))}
  </>
);
